import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { UrlBuilderService } from 'src/app/utils/tovpil-url-builder.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { StatusType } from 'src/app/shared/vo/StatusType';

@Component({
  selector: 'app-fv-summary-matter-recpay',
  templateUrl: './fv-summary-matter-recpay.component.html',
  styleUrls: ['./fv-summary-matter-recpay.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService]
})
export class FvSummaryMatterRecpayComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** COMPONENT */
  languages: any[];
  periods: any[];
  currencies: any[];

  /** DATAPARENT */
  dataParent: any = {};

  /** PIPES */
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT OVERLAY */
  blocked: boolean = false;

  /** ENDPOINTS */
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPointGetValidPeriods = "getValidPeriods";
  endPointGetCurrencyByStoreId = "getListCurrencyByStoreId";
  endPointGetStoreById = "getStoreById";
  endPointGetRecPayById = "getRecpayById";
  endPointDeleteRecPayById = "deleteRecpay";
  endPointGetGuideAndStoreName = "getGuideStoreAndLastname";

  endPointCreateRecPay = "createRecpay";
  endPointUpdateRecPay = "updateRecpay";

  /**
   * This constructor function initializes various services and variables used in the component, and also
   * checks for authentication based on the token and device parameters passed in the URL.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user. It is likely used to show success or error messages during certain
   * operations.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
   * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
   * confirmation before performing certain actions.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API requests and handling responses.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to access the current route's information. It provides access to the route's
   * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
   * used to subscribe to the
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
   * the current user's information.
   * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
   * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
   * downloading files.
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
   * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
   * on data in the application.
   * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
   * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
   */
  constructor(
    private apiService: ApiService,
    private confirmationService: ConfirmationService,
    private fb: FormBuilder,
    private tovpilUtils: TovpilUtilsService,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private router: Router,
    private userPreferencesService: UserPreferencesService,
    private translationService: TovpilLanguageService,
    private route: ActivatedRoute,
    private urlBuilderService: UrlBuilderService,
  ) {
    this.createDataForm();
    this.initConfigs();

    this.route.queryParams.subscribe(params => {
      this.dataParent.type = params.type;
      this.dataParent.opt = params.opt;

      this.dataParent.storeId = params.storeId;

      this.dataParent.currDate = params.currDate;
      this.dataParent.sequen = params.sequen;
      this.dataParent.conceptId = params.conceptId;
      this.dataParent.currCode = params.currCode;
      this.dataParent.unitId = params.unitId;
      this.dataParent.unitType = params.unitType;
      this.dataParent.sequence = params.sequence;
      this.dataParent.date = params.date;
      this.dataParent.period = params.period;
    });

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const currentUser = this.authenticationService.currentUserValue;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    } else {
      //this.globalUserPreferences.currentUser = currentUser;
    }
  }

  /**
    * The function initializes form groups for configuration and data, and updates the configuration form
    * with query parameters from the route.
    */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences = await this.userPreferencesService.getSantovTovpilCookie() || null;
    console.debug("FiiReceivePayable() Preferencuas de usuario: " + JSON.stringify(this.globalUserPreferences, null, 2));
  }

  /**
    * The function `createDataForm` in TypeScript initializes a form group with various form controls and
    * default values, as well as setting some controls as disabled.
    */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedCurrency: new FormControl({ value: null, disabled: true }),
      selectedCoordination: new FormControl({ value: null, disabled: true }),
      selectedConcept: new FormControl({ value: null, disabled: true }),
      selectedMenuOption: new FormControl({ value: "CXC2" }),
      selectedIdRegister: new FormControl({ value: null, disabled: true }),
      selectedMinDate : new FormControl(null),
      selectedMaxDate : new FormControl(null),

      // CRUD
      selectedDocument: new FormControl(null, [Validators.required, Validators.maxLength(20), Validators.minLength(1)]),
      selectedDate: new FormControl({ value: null, disabled: false }, Validators.required),
      selectedAmount: new FormControl({ value: null, disabled: false }, Validators.required),
      selectedComments : new FormControl({value: null, disabled : false})
    });
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    const currentUser = this.authenticationService.currentUserValue;
    //this.globalUserPreferences.currentUser = currentUser;

    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn'n', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        error => {
          //this.messageService.add({ severity: 'warn'n', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences = data;
    }

    this.getTranslatedLabels();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      await this.getLanguages();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      //this.messageService.add({ severity: 'warn'n', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga ETIQUETAS, inténtelo más tarde' });
    }
  }

  /**
   * The function is an asynchronous function that fetches a list of languages and handles
   * any errors that occur during the process.
   */
  async getLanguages() {
    console.debug("FiiReceivePayable() Debug > Material Languages");

    const language = this.globalUserPreferences?.preferences?.language || null;
    const storeId = this.globalUserPreferences?.preferences?.coordinationId || null;

    try {
      const result = await this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, { language, storeId });

      if (result.success) {
        this.languages = result.data;

        if (language && storeId) {
          let selectedLanguage = this.languages.find(o => o.valueId === language);

          // NO EXISTE PARA ESA COORDINACION EL SELECCIONADO
          if (selectedLanguage == null && this.languages.length > 0) {
            selectedLanguage = this.languages[0];
          }

          this.globalUserDataForm.patchValue({
            selectedLanguage: selectedLanguage
          });

          await this.getInitData();
        }
      } else {
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn'n', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
      }
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      //this.messageService.add({ severity: 'warn'n', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
    }
  }

  /**
    * This TypeScript function asynchronously fetches a list of currencies based on store ID and language
    * ID, handling errors and returning the data if successful.
    * @returns The function returns either the fetched currency data if
    * successful, or `null` if there are missing parameters, an error occurred during fetching, or an
    * exception was caught.
    */
  async getListCurrencyByStoreId(storeId: string, language: string, currency: string) {
    try {

      if (!storeId || !language) {
        console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetCurrencyByStoreId, {
        storeId,
        language: language,
      });

      if (result.success) {
        let lstCurrencies = result.data;
        let currencySelected = currency ? lstCurrencies.find(o => o.valueId === currency) ?? lstCurrencies[0] : lstCurrencies[0] ?? null;
        this.currencies = lstCurrencies;

        this.globalUserDataForm.patchValue({
          selectedCurrency: currencySelected
        });
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError('CURRENCY Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function asynchronously fetches store data and updates the global user data
   * form with the retrieved information.
   * @returns The function returns a boolean value (`true` or `false`) based on the
   * success of fetching store data and updating the value in the
   * `globalUserDataForm`. If the store data is successfully fetched, it returns `true`. If there is an
   * error during the process, it returns `false`.
   */
  async getCoordination(storeId: string, formControlName: string) {
    try {
      if (!storeId || !formControlName) {
        console.warn('Missing required parameters: storeId and formControlName are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetStoreById, { storeId });

      if (result.success) {
        const storeDescription = result.data?.storeId + ' ' + result.data?.descri;
        this.globalUserDataForm.patchValue({ [formControlName]: storeDescription });
        return true;
      } else {
        console.error("An error occurred while fetching store data:");
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getInitData() {
    try {

      const language = this.globalUserPreferences?.preferences?.language || null;
      const currency = this.globalUserPreferences?.preferences?.selCurrency || null;
      const coordinationStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const toCoordinationStoreId = this.dataParent.toStoreId || null;
      const sequence = this.dataParent.sequence || null;
      const conceptId = this.dataParent.conceptId || null;
      const year = this.globalUserPreferences?.preferences?.periodSelected?.year ?? null;
      const unitType = this.dataParent.unitType ?? null;
      const unitId = this.dataParent.unitId ?? null;

      let accBalanceCD;
      let accBalanceH;

      await this.getListCurrencyByStoreId(coordinationStoreId, language, currency);
      await this.getCoordination(coordinationStoreId, 'selectedCoordination');
      await this.getCoordination(toCoordinationStoreId, 'selectedToCoordination');
      this.setMaxMinDate();

      if (sequence != null) {
        accBalanceH = await this.apiService.getAccBalanceHById({
          year: year,
          sequence: sequence
        });

        accBalanceCD = await this.apiService.getAccBalanceCDById({
          year: year,
          sequence: sequence,
          seqd: "01"
        });
      }

      this.globalUserDataForm.patchValue({
        selectedType: this.dataParent.type === 'AR' ? 'Cuentas por Cobrar' : 'Cuentas por Pagar',
        selectedIdRegister: (accBalanceCD != null ? `${accBalanceCD.id.year} ${accBalanceCD.id.sequence}` : ""),
        selectedConcept: this.dataParent?.conceptId,
        selectedAmount: accBalanceCD != null ? accBalanceCD.amount : "",
        selectedDate: accBalanceH != null ? this.tovpilUtils.stringToDate(accBalanceH.movDate) : null,
        selectedDocument: accBalanceH != null ? accBalanceH.docId : "",
        selectedComments : accBalanceCD != null ? accBalanceCD.comments : ""
      });

    } catch (error) {
      console.error("An error occurred while fetching price list:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }

  /**
   * The `saveRecPay` function in TypeScript handles the saving of a record payment with error handling
   * and data validation.
   * @returns The `saveRecPay()` function returns a boolean value - `true` if the operation is successful
   * and `false` if there is an error during the process.
   */
  async saveRecPay() {
    try {
      this.blocked = true;

      this.globalUserDataForm.markAsUntouched();
      event.preventDefault();
      this.validateAllFormFields(this.globalUserDataForm);


      if (!this.globalUserDataForm.valid) {
        this.blocked = false;
        return;
      }


      const selectedDate = this.globalUserDataForm.get('selectedDate').value;
      const year = this.globalUserPreferences?.preferences?.periodSelected?.year ?? null;
      const selectedConcept = this.globalUserDataForm.get('selectedConcept').value;
      const selectedDocument = this.globalUserDataForm.get('selectedDocument').value;
      const selectedAmount = this.globalUserDataForm.get('selectedAmount').value;
      const selectedComments = this.globalUserDataForm.get('selectedComments').value;
      const unitId = this.dataParent.unitId;
      const unitType = this.dataParent.unitType;
      const currency = this.dataParent.currCode || null;
      const sequence = this.dataParent.sequence || null;
      const userId = this.globalUserPreferences?.preferences?.userId;
      const menuOption = "CXC2";
      const unitIdFrom = this.dataParent.storeId;

      const accbalanceheader = {
        id: {
          year: /* The above code is a comment in TypeScript. It appears to be a placeholder for a
          question about a variable or concept related to the "year" variable. */
          year,
          sequence: sequence
        },
        docId: selectedDocument,
        menuOption: menuOption,
        movDate: this.tovpilUtils.dateToTovpilDate(selectedDate) ?? null,
        status: "N",
        currDate: "",
        userId: userId
      };

      this.confirmationService.confirm({
        message: `¿${this.translations.lbl_are_you_sure}?`,
        header: this.translations.lbl_confirm,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.translations.lbl_yes,
        rejectLabel: this.translations.lbl_back,
        accept: async () => {
          const endPoint = this.dataParent.opt === 'create' ? this.endPointCreateRecPay : this.endPointUpdateRecPay;
          let resultH;
          let resultCD;
          if (this.dataParent.opt == 'create') {
            resultH = await this.apiService.createAccBalanceH(accbalanceheader);

            const accbalancedetail = {
              id: {
                year: resultH.id.year,
                sequence: resultH.id.sequence,
              },
              accountId: selectedConcept,
              unitIdFrom: unitIdFrom,
              unitTypeFrom: "S",
              unitIdTo: unitId,
              unitTypeTo: unitType,
              currencyId: currency,
              amount: selectedAmount,
              comments: selectedComments,
              chargeType: "R"
            }

            resultCD = await this.apiService.createDoublePartyDetail(accbalancedetail);
          } else if (this.dataParent.opt == 'update') {
            resultH = await this.apiService.updateAccBalanceH(accbalanceheader);
            const request = {
              year: resultH.id.year,
              sequence: resultH.id.sequence,
              totAmt: selectedAmount,
              comments : selectedComments
            }
            resultCD = await this.apiService.updateDoublePartyDetail(request);
          }

          if (resultH != null && resultCD.status == StatusType.OK) {
            this.blocked = false;
            this.goBack();
            return true;
          } else {
            // this.goBack();
            console.error("An error occurred while fetching store data:");
            return false;
          }
        }, reject: () => {
          console.warn("rechazo accion de guardar");
        }
      });

    } catch (error) {
      console.error(error);
      return false;
    } finally {
      this.blocked = false;
    }
  }

   setMaxMinDate(){
    const year = parseInt(this.globalUserPreferences?.preferences?.periodSelected?.year) ?? null;
    const period = this.dataParent.period;
    if(period === '1'){
      this.globalUserDataForm.patchValue({
        selectedMinDate: new Date(year, 0, 1),
        selectedMaxDate : new Date(year, 5, 30)
      });
    }
    if(period === '2'){
      this.globalUserDataForm.patchValue({
        selectedMinDate: new Date(year, 6, 1),
        selectedMaxDate : new Date(year, 11, 31)
      });
    }
  }


  /**
   * The `deleteRecPay` function is an asynchronous method that handles the deletion of a record,
   * including form validation, fetching data, and error handling.
   * @returns The `deleteRecPay()` method returns a boolean value - `true` if the deletion operation is
   * successful, and `false` if there is an error during the process.
   */
  async deleteRecPay() {
    try {
      this.blocked = true;

      this.globalUserDataForm.markAsUntouched();
      event.preventDefault();
      this.validateAllFormFields(this.globalUserDataForm);

      if (!this.globalUserDataForm.valid) {
        return;
      }
      const year = this.globalUserPreferences?.preferences?.periodSelected?.year ?? null;
      const sequence = this.dataParent.sequence ?? null;
      const accbalanceheader = {
        year: year,
        sequence: sequence
      };
      this.confirmationService.confirm({
        message: `¿${this.translations.lbl_are_you_sure} ${this.translations.lbl_of} ${this.translations.lbl_delete_record}?`,
        header: this.translations.lbl_confirm,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.translations.lbl_yes,
        rejectLabel: this.translations.lbl_back,
        accept: async () => {
          let res = await this.apiService.deleteFV(accbalanceheader);
          if (res.status != StatusType.OK)
            throw Error("Error on delete");
          this.goBack();
        },
        reject: () => {
          console.warn("rechazo accion de guardar");
        }
      });
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      this.blocked = false;
    }
  }

  /**
   * The `onChangeUserPreferences` function updates user preferences including language, period, and
   * currency, and then updates the user preferences entity, cookie, and triggers a reload.
   */
  async onChangeUserPreferences() {

    console.debug("FiiReceivePayable() onChangeUserPreferences")
    await this.refreshPreferences();

    // RECARGA
    this.initConfigs();
    this.getLanguages();
  }

  /* The above TypeScript code is updating properties of a user object, specifically setting the
      languageId, currencyId, periodYear, and periodMonth based on the provided values or null if not
      provided. It also updates the periodSelected property with the provided period value. Finally,
      it updates a cookie named "userPreferences" with the updated globalUserPreferences object using
      a cookie service. */
  async refreshPreferences() {
    // SOLO SE ACTUALIZA LA COOKIE
    let language = (this.globalUserDataForm.get('selectedLanguage')?.value)?.valueId || null;
    let period = (this.globalUserDataForm.get('selectedPeriod')?.value) || null;
    let currency = (this.globalUserDataForm.get('selectedCurrency')?.value)?.valueId || null;


    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    this.userPreferencesService.updateTovpilCookie(
      null, // _levelId
      null, //_userId
      null, //_storeId
      null, //_id
      language || null, //_language
      currency || null, //_selCurrency
      null, //_coordinationId
      null, //_coordinationStack
      period?.year || null, //_selYear
      period?.period || null, //_selPeriod
      null, //_device
      null, //_storeSelected
      period, //_periodSelected
      null //_stores
    );
  }

  /**
   * The `goBack` function navigates to a specific URL with query parameters based on certain conditions
   * and handles errors accordingly.
   */
  goBack() {
    try {
      const currCode = this.globalUserPreferences?.preferences?.selCurrency || null;

      const queryParams = {
        currCode: currCode || null,
        type: this.dataParent.type || null,
        storeId: this.dataParent.storeId || null,
        conceptId: this.dataParent.conceptId || null,
        unitId: this.dataParent.unitId || null,
        unitType: this.dataParent.unitType || null,
        date: this.dataParent.date || null
      };

      this.refreshPreferences();

      try {
        const url = this.urlBuilderService.buildUrl('/treasurer/receivableLstHDtl', queryParams);
        this.router.navigateByUrl(url);

      } catch (navigationError) {
        console.error("An error occurred while navigating to coordination catalog details:", navigationError);
        //this.handleError('Redirigir a CX4', 'Algo salio mal al redirigir a CX4');
      }
    } catch (parseError) {
      console.error("An error occurred while parsing state to JSON:", parseError);
      //this.handleError('Redirigir a CX4', 'Algo salio mal al redirigir a CX4');
    }
  }

  /**
   * The function recursively marks all form fields in a FormGroup as touched.
   * @param {FormGroup} formGroup - The `formGroup` parameter in the `validateAllFormFields` function is
   * of type `FormGroup`, which represents a group of form controls in Angular. It contains form controls
   * such as `FormControl`, `FormGroup`, and `FormArray` that are used to build and manage forms in
   * Angular applications.
   */
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}

